import * as React from "react";
import {default as MuiPopover} from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import "./popover.styles.scss";

export default function Popover(props) {
	const { btnOpened, title, description, anchorA, anchorH, transA, transH, className, image, imageWidth, closeTime, children } = props;

	const [anchorEl, setAnchorEl] = React.useState(null);

	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	React.useEffect(()=>{
		closeTime && open && setTimeout(()=>{
			handleClose();
		},closeTime);
	},[closeTime, open]);

    
	return (
		<React.Fragment>
			{children && <div
                className={className}
				aria-describedby={id}
				onClick={handleClick}
                style={{
					display:"inline-flex",
					alignItems:"end",
                    minWidth:"0"
                }}>
				{children}
			</div>}
			{!children && <span
                className={className}
				aria-describedby={id}
				onClick={handleClick}
                style={{
                    minWidth:"0",
					fontSize: open?"11px":"inherit"
                }}
			>
				{open? '✕':btnOpened}
			</span>
			}
			<MuiPopover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: anchorA?anchorA:"top",
					horizontal: anchorH?anchorH:"left",
				}}
                transformOrigin={{
                    vertical: transA?transA:'bottom',
                    horizontal: transH?transH:'left',
                }}
			>
				<div className="popup-container">
					{title && <Typography className="popup-title-container" onClick={handleClose} dangerouslySetInnerHTML={{__html:title}}></Typography>}
					{description && <Typography className="popup-desc-container"onClick={handleClose} dangerouslySetInnerHTML={{__html:description}}></Typography>}
					{image && <div className="popover-image-container"><img src={image} alt="popup-img" style={{width:imageWidth}}></img></div>}
				</div>
			</MuiPopover>
		</React.Fragment>
	);
}
